<template>
  <div class="AI-copywriting-container" v-if="isOpen">
    <h3 class="title">AI文案</h3>
    <div class="main-box">
      <div
        class="chat-box"
        :class="{
          disabled: isCreate,
        }"
      >
        <div class="chat-list" @scroll="chatListScroll" ref="chatList">
          <div class="list">
            <div
              class="chat-item"
              :class="item.type"
              v-for="(item, index) in chatList"
              :key="index"
            >
              <img
                class="avatar"
                :src="item.type == 'ask' ? askAvatar : answerAvatar"
                alt=""
              />
              <div class="content">
                <p v-html="item.content"></p>
                <span v-show="item.type == 'answer' && index != 0" class="tips"
                  >本内容由AI生成</span
                >
              </div>
            </div>
            <div class="chat-item answer" v-show="isCreate">
              <img class="avatar" :src="answerAvatar" alt="" />
              <p class="content">AI正在创作中请稍等片刻{{ ellipsisText }}</p>
            </div>
          </div>
        </div>
        <div
          class="input-box"
          :class="{
            disabled: isCreate,
          }"
        >
          <textarea
            :style="{
              height: textareaHeight + 'px',
            }"
            :placeholder="isCreate ? 'AI正在创作中' : '输入内容开始创作'"
            v-model="inputText"
            resize="none"
            @input="textareaInput"
            @keydown="confirm"
            ref="textarea"
          />
          <div class="icon-box" @click="confirm">
            <i class="el-icon-s-promotion"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { singleDrawWork, createAiText, findUserFuncInfo } from "@/api";
let timer = null;
let timerNum = 0;
let ellipsisTextAniTimer = null;

export default {
  data() {
    return {
      isCreate: "",
      ellipsisText: "",
      isPauseScroll: false,
      inputText: "",
      textareaHeight: 25,
      askAvatar: require("@/assets/img/AI/avatar-ask.png"),
      answerAvatar: require("@/assets/img/AI/avatar-answer.png"),
      chatList: [
        // {
        //   type: "ask",
        //   content: "我想问问你大爷的大爷我应该叫什么？",
        // },
        // {
        //   type: "answer",
        //   content:
        //     "要是有一个是爷爷辈的,就应该叫太爷 要是两个都不是爷爷辈的,就应该叫爷爷 要是两个都是爷爷辈的,就应该叫祖太爷你爸的哥哥 那你叫大爷就行(爷爷辈的,爷字叫时要二声要重点) 我大爷的大爷,也就是我父亲的大爷。因为我大爷是我父亲的亲哥哥。 我父亲的大爷是我爷爷的亲哥哥。因此我管他叫大爷爷。爷爷的兄弟都得叫爷爷。",
        // },
        // {
        //   type: "ask",
        //   content: "我想问问你大爷的大爷我应该叫什么？",
        // },
        // {
        //   type: "answer",
        //   content:
        //     "要是有一个是爷爷辈的,就应该叫太爷 要是两个都不是爷爷辈的,就应该叫爷爷 要是两个都是爷爷辈的,就应该叫祖太爷你爸的哥哥 那你叫大爷就行(爷爷辈的,爷字叫时要二声要重点) 我大爷的大爷,也就是我父亲的大爷。因为我大爷是我父亲的亲哥哥。 我父亲的大爷是我爷爷的亲哥哥。因此我管他叫大爷爷。爷爷的兄弟都得叫爷爷。",
        // },
        // {
        //   type: "ask",
        //   content: "我想问问你大爷的大爷我应该叫什么？",
        // },
        // {
        //   type: "answer",
        //   content:
        //     "要是有一个是爷爷辈的,就应该叫太爷 要是两个都不是爷爷辈的,就应该叫爷爷 要是两个都是爷爷辈的,就应该叫祖太爷你爸的哥哥 那你叫大爷就行(爷爷辈的,爷字叫时要二声要重点) 我大爷的大爷,也就是我父亲的大爷。因为我大爷是我父亲的亲哥哥。 我父亲的大爷是我爷爷的亲哥哥。因此我管他叫大爷爷。爷爷的兄弟都得叫爷爷。",
        // },
        // {
        //   type: "ask",
        //   content: "我想问问你大爷的大爷我应该叫什么？",
        // },
        // {
        //   type: "answer",
        //   content:
        //     "要是有一个是爷爷辈的,就应该叫太爷 要是两个都不是爷爷辈的,就应该叫爷爷 要是两个都是爷爷辈的,就应该叫祖太爷你爸的哥哥 那你叫大爷就行(爷爷辈的,爷字叫时要二声要重点) 我大爷的大爷,也就是我父亲的大爷。因为我大爷是我父亲的亲哥哥。 我父亲的大爷是我爷爷的亲哥哥。因此我管他叫大爷爷。爷爷的兄弟都得叫爷爷。",
        // },
      ],
      isOpen: false,
      isClick: false,
      isPauseScroll: false,
    };
  },
  mounted() {
    findUserFuncInfo({
      userFuncType: 16,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30) {
          this.isOpen = true;
          setTimeout(() => {
            this.chatList.push({
              type: "answer",
              content:
                "你好我是人工智能文案助手，我能像人类一样来聊天交流,甚至能完成文案、翻译、代码,写论文，请在下方输入框输入文字与我对话试试吧！",
            });
          }, 2e2);
        }
      }
    });
  },
  methods: {
    confirm(e) {
      console.log(e);
      if ((e.which === 13 && e.ctrlKey) || (e.which == 10 && e.ctrlKey)) {
        this.inputText = this.inputText + "\n";
        this.textareaHeight = this.textareaHeight + 25;
        this.$refs.textarea.scrollTop = this.$refs.textarea.scrollHeight + 100;
      } else if (e.which == 13 || e.which == 1) {
        e.preventDefault();
        if (!this.inputText) {
          return this.$notify({
            title: "提示",
            message: "请输入描述词",
            type: "error",
            duration: 2000,
          });
        }
        if (this.isClick) return;
        this.setClickStatus();
        let inputText = this.inputText;
        this.chatList.push({
          type: "ask",
          content: this.inputText.replace(/\n/g, "<br />"),
        });
        this.inputText = "";
        this.textareaHeight = 25;
        this.$refs.textarea.blur();
        this.isCreate = true;
        this.ellipsisTextAni();
        createAiText({
          inputPrompt: inputText,
        }).then((res) => {
          this.isClick = false;
          if (res.code == 1) {
            this.singleDrawWork(res.data.drawWorkId);
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        });
      }
    },
    setClickStatus() {
      this.isClick = true;
      setTimeout(() => {
        this.isClick = false;
      }, 1e4);
    },
    singleDrawWork(drawWorkId) {
      singleDrawWork({
        drawWorkId,
      }).then((res) => {
        if (res.code == 1) {
          clearTimeout(timer);
          timer = null;
          this.createStatus = res.data.workResultStatus;
          if (res.data.workResultStatus == 199 || res.data.workResultStatus == 200) {
            this.isCreate = false;
          }
          if (res.data.workResultStatus == 199) {
            this.$notify({
              title: "提示",
              message: res.data.workResultMsg,
              type: "error",
              duration: 2000,
            });
          } else if (res.data.workResultStatus == 200) {
            this.chatList.push({
              type: "answer",
              content: res.data.workText,
            });
            this.newMessageScrollFuc();
          } else {
            let timeInterval = 3;
            timerNum++;
            if (120 / (timerNum * timeInterval) <= 1) {
              timerNum = 0;
              this.isCreate = false;
              return this.$notify({
                title: "提示",
                message: "生成超时，请稍后再试",
                type: "error",
                duration: 0,
              });
            }
            timer = setTimeout(() => {
              this.singleDrawWork(drawWorkId);
            }, timeInterval * 1e3);
          }
        }
      });
    },
    newMessageScrollFuc() {
      if (
        !this.isPauseScroll &&
        this.$refs.chatList.scrollHeight > this.$refs.chatList.clientHeight
      ) {
        this.$refs.chatList.scrollTop = this.$refs.chatList.scrollHeight;
      }
    },
    chatListScroll(e) {
      if (e.target.scrollTop + 10 < e.target.scrollHeight - e.target.clientHeight) {
        this.isPauseScroll = true;
      } else {
        this.isPauseScroll = false;
      }
    },
    chatListScrollToBottom() {
      this.isPauseScroll = false;
      this.$refs.chatList.scrollTop = this.$refs.chatList.scrollHeight;
    },
    textareaInput(e) {
      console.log(e);
      this.textareaHeight =
        (parseInt(this.checkCh(this.inputText) / 79) + 1) * 25 +
        (e.target.value.split("\n").length - 1) * 25;
    },
    checkCh(str) {
      var len = 0;
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255) {
          len += 2;
        } else {
          len++;
        }
      }
      return len;
    },
    ellipsisTextAni() {
      clearInterval(ellipsisTextAniTimer);
      ellipsisTextAniTimer = null;
      ellipsisTextAniTimer = setInterval(() => {
        if (!this.isCreate) {
          clearInterval(ellipsisTextAniTimer);
          this.ellipsisText = "";
          return;
        }
        if (this.ellipsisText.length == 3) {
          this.ellipsisText = "";
          return;
        }
        this.ellipsisText += ".";
        this.ellipsisText = this.ellipsisText;
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.AI-copywriting-container {
  padding: 20px;
  font-family: "思源黑体";
  height: calc(100% - 50px);
  box-sizing: border-box;
  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 44px;
    margin-bottom: 10px;
  }
  .main-box {
    height: calc(100% - 44px);
    .chat-box {
      &.disabled {
        cursor: not-allowed;
      }
      position: relative;
      height: 100%;
      width: 785px;
      .chat-list {
        height: calc(100% - 120px);
        overflow: auto;
        &::-webkit-scrollbar {
          display: block;
          width: 8px;
          height: 8px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(204, 204, 204, 0.8);
        }
        &::-webkit-scrollbar-thumb:hover {
          background: rgba(204, 204, 204, 1);
        }
        .list {
          padding-bottom: 50px;
          .chat-item {
            display: flex;
            padding: 20px 50px 20px 30px;
            align-items: flex-start;
            justify-content: flex-start;
            &.answer {
              background-color: rgba(247, 247, 248, 1);
              .content {
                color: rgba(96, 93, 95, 1);
              }
              .tips {
                display: inline-block;
                border-radius: 20px;
                margin-top: 10px;
              }
            }
            .avatar {
              width: 38px;
              height: 38px;
              margin-right: 15px;
              background-color: rgba(2, 0, 3, 1);
            }
            .content {
              font-size: 17px;
              line-height: 25px;
              margin-top: 7px;
            }
          }
        }
      }
      .input-box {
        position: absolute;
        bottom: 50px;
        opacity: 1;
        border-radius: 5px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 13px 0 rgba(143, 143, 143, 0.25);
        border: 1px solid rgba(232, 232, 232, 1);
        z-index: 9;
        width: 100%;
        display: flex;
        padding: 14px 16px;
        box-sizing: border-box;
        align-items: flex-end;
        &.disabled {
          pointer-events: none;
          cursor: not-allowed;
          background: #dddddd;
          textarea {
            background: #dddddd;
          }
        }
        textarea {
          width: 100%;
          font-size: 17px;
          line-height: 25px;
          border: 0;
          outline: none;
          resize: none;
          max-height: 200px;
          overflow-y: hidden;
          padding: 0;
          height: 25px;
          padding-right: 20px;
          font-family: monospace;
        }
        .icon-box {
          width: 25px;
          height: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          &:hover {
            background-color: rgba(236, 236, 241, 0.8);
            cursor: pointer;
          }
          i {
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>
